import { z } from "zod";
import { ROUTE_CODE_MAX } from "../constants";

// ─── Countries ────────────────────────────────────────────────────────────────

export const createCountrySchema = z.object({
  name:    z.string().min(1, "El nombre es requerido").max(100),
  isoCode: z.string().length(2, "El código ISO debe tener exactamente 2 caracteres")
             .toUpperCase(),
  code:    z.string().min(1).max(10).toUpperCase().nullable().optional(),
});

export const updateCountrySchema = createCountrySchema.partial();

// ─── States ───────────────────────────────────────────────────────────────────

export const createStateSchema = z.object({
  name:      z.string().min(1, "El nombre es requerido").max(100),
  code:      z.string().min(1, "El código es requerido").max(10).toUpperCase(),
  countryId: z.string().uuid("ID de país inválido"),
});

export const updateStateSchema = createStateSchema.partial();

// ─── Cities ───────────────────────────────────────────────────────────────────

export const createCitySchema = z.object({
  name:     z.string().min(1, "El nombre es requerido").max(150),
  code:     z.string().min(1, "El código es requerido").max(10).toUpperCase(),
  stateId:  z.string().uuid("ID de provincia inválido"),
  type:     z.enum(["city", "trayectory"]).default("city"),
  sgtCodes: z.array(z.string().max(200)).nullable().optional(),
});

export const updateCitySchema = createCitySchema.partial();

// ─── Types ────────────────────────────────────────────────────────────────────

export type CreateCountryInput = z.infer<typeof createCountrySchema>;
export type UpdateCountryInput = z.infer<typeof updateCountrySchema>;
export type CreateStateInput   = z.infer<typeof createStateSchema>;
export type UpdateStateInput   = z.infer<typeof updateStateSchema>;
export type CreateCityInput    = z.infer<typeof createCitySchema>;
export type UpdateCityInput    = z.infer<typeof updateCitySchema>;

// ─── Routes ──────────────────────────────────────────────────────────────

export const createRouteSchema = z.object({
  code:         z.string().min(1, "El código es requerido").max(ROUTE_CODE_MAX).toUpperCase(),
  name:         z.string().min(1, "El nombre es requerido").max(200),
  originCityId: z.string().uuid("ID de ciudad origen inválido"),
  targetCityId: z.string().uuid("ID de ciudad destino inválido"),
  km:           z.number().int("KM debe ser entero").nonnegative("KM no puede ser negativo").optional(),
  deletedAt:    z.string().datetime("deletedAt debe ser una fecha ISO válida").nullable().optional(),
});

export const updateRouteSchema = createRouteSchema.partial();

export type CreateRouteInput = z.infer<typeof createRouteSchema>;
export type UpdateRouteInput = z.infer<typeof updateRouteSchema>;
